export default __webpack_public_path__ + "static/media/city_background.8dc7ce16.jpg";